<template>
  <div>
    <!-- Identificación (opcional; si no lo usas, puedes ocultarlo) -->
    <fieldset class="mb-6">
      <legend class="text-xl font-semibold text-gray-900 mb-2">Modo de identificación</legend>
      <p class="text-gray-600 mb-4">El nombre de cada imagen dentro del ZIP representará:</p>

      <div class="space-y-3">
        <label class="flex items-center cursor-pointer">
          <input type="radio" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            name="identification-type" value="nombre" :checked="localIdentificationType === 'nombre'"
            @change="updateIdentification('nombre')" />
          <span class="ml-3 text-gray-700">Nombre del residente</span>
        </label>

        <!-- <label class="flex items-center cursor-pointer">
          <input type="radio" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500"
            name="identification-type" value="telefono" :checked="localIdentificationType === 'telefono'"
            @change="updateIdentification('telefono')" />
          <span class="ml-3 text-gray-700">Número de teléfono</span>
        </label> -->
      </div>
    </fieldset>

    <!-- Uploader -->
    <div
      class="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 hover:bg-gray-50 transition-colors"
      :class="{ 'ring-2 ring-blue-400 border-blue-400': isDragging }" role="button" tabindex="0"
      @keydown.enter.prevent="triggerFileDialog" @keydown.space.prevent="triggerFileDialog"
      @dragenter.prevent="onDragEnter" @dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave"
      @drop.prevent="onDrop" aria-describedby="uploader-help">
      <p id="uploader-help" class="text-gray-500 mb-4">
        Arrastra y suelta un archivo .zip aquí o
      </p>

      <div class="flex flex-col items-center gap-3">
        <input ref="fileInput" type="file" accept=".zip,application/zip" class="hidden" @change="onFileChange" />
        <button type="button" @click="triggerFileDialog"
          class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors disabled:bg-gray-300"
          :disabled="isSubmitting">
          Seleccionar ZIP
        </button>

        <p v-if="file" class="text-sm text-gray-700">
          Seleccionado: <span class="font-medium">{{ file.name }}</span>
          <span class="text-gray-500"> ({{ humanSize(file.size) }})</span>
        </p>

        <p class="text-xs text-gray-500">
          Límite: {{ maxSizeMb }} MB
        </p>
      </div>
    </div>

    <!-- Acciones -->
    <div class="mt-6 flex items-center justify-between">
      <div class="text-sm">
        <span v-if="errorMsg" class="text-red-600">{{ errorMsg }}</span>
        <span v-else-if="infoMsg" class="text-gray-600">{{ infoMsg }}</span>
      </div>

      <!-- <button type="button"
        class="bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-6 py-2 rounded-lg font-medium transition-colors"
        :disabled="!file || isSubmitting || !!errorMsg" @click="submit">
        <span v-if="!isSubmitting">Subir</span>
        <span v-else class="inline-flex items-center">
          <svg class="animate-spin -ml-1 mr-2 h-4 w-4" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
          Subiendo...
        </span>
      </button> -->
      <button v-if="errorMsg" type="button"
        class="bg-gray-900 hover:bg-gray-800 disabled:bg-gray-300 disabled:cursor-not-allowed text-white px-6 py-2 rounded-lg font-medium transition-colors"
        :disabled="isSubmitting" @click="submit">
        Reintentar
      </button>

    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from 'vue'
import { ingestZip } from '@/store/facialIngest'
import { showLoading, hideLoading } from '@/utils/loading'

export default {
  name: 'IngestZipForm',
  props: {
    token: { type: String, required: true },
    baseUrl: { type: String, default: '/api/residents/facial-recognition' },
    maxSizeMb: { type: Number, default: 500 },
    identificationType: { type: String, default: 'nombre' }
  },
  setup(props, { emit }) {
    const isDragging = ref(false)
    const file = ref(null)
    const isSubmitting = ref(false)
    const errorMsg = ref('')
    const infoMsg = ref('')

    // 👇 ESTE ES EL REF QUE VA LIGADO AL input ref="fileInput"
    const fileInput = ref(null)

    const localIdentificationType = ref(props.identificationType)
    watch(() => props.identificationType, (v) => {
      localIdentificationType.value = v
    })

    const maxBytes = computed(() => props.maxSizeMb * 1024 * 1024)

    const triggerFileDialog = () => {
      if (fileInput.value) {
        fileInput.value.click()
      }
    }

    const onDragEnter = () => { isDragging.value = true }
    const onDragOver = () => { isDragging.value = true }
    const onDragLeave = () => { isDragging.value = false }

    const onDrop = (e) => {
      isDragging.value = false
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]
      if (f) validateAndSetFile(f)
    }

    const onFileChange = (e) => {
      const f = e.target.files && e.target.files[0]
      if (f) validateAndSetFile(f)
    }

    function validateAndSetFile(f) {
      errorMsg.value = ''
      infoMsg.value = ''

      const isZip =
        f.type === 'application/zip' ||
        /\.zip$/i.test(f.name)

      if (!isZip) {
        errorMsg.value = 'Por favor selecciona un archivo ZIP válido.'
        file.value = null
        return
      }
      if (f.size > maxBytes.value) {
        errorMsg.value = `El archivo excede el límite de ${props.maxSizeMb} MB.`
        file.value = null
        return
      }
      file.value = f

      submit()

      // infoMsg.value = 'Listo para subir.'
    }

    function updateIdentification(next) {
      localIdentificationType.value = next
      emit('update:identificationType', next)
    }

    function humanSize(bytes) {
      const thresh = 1024
      if (Math.abs(bytes) < thresh) return bytes + ' B'
      const units = ['KB', 'MB', 'GB', 'TB']
      let u = -1
      do { bytes /= thresh; ++u } while (Math.abs(bytes) >= thresh && u < units.length - 1)
      return bytes.toFixed(1) + ' ' + units[u]
    }

    async function submit() {
      if (!file.value || isSubmitting.value) return

      errorMsg.value = ''
      infoMsg.value = ''
      isSubmitting.value = true
      showLoading('Subiendo archivo...')

      try {
        const form = new FormData()
        form.append('file', file.value)
        form.append('identificationMode', localIdentificationType.value)

        const payload = await ingestZip({
          file: file.value,
          identificationMode: localIdentificationType.value,
        })

        if (payload?.jobId) {
          emit('uploaded', { jobId: payload.jobId })
          infoMsg.value = payload.message || 'Archivo aceptado, iniciando procesamiento...'
        } else {
          const msg = payload?.error || payload?.message || 'No se pudo iniciar la ingesta.'
          errorMsg.value = msg
          emit('error', msg)
        }
      } catch (e) {
        errorMsg.value = e.message || 'Error al subir el archivo.'
        emit('error', errorMsg.value)
      } finally {
        isSubmitting.value = false
        hideLoading()
      }
    }

    return {
      // state
      isDragging,
      file,
      isSubmitting,
      errorMsg,
      infoMsg,
      localIdentificationType,
      fileInput,          // 👈 IMPORTANTE: devolverlo para que el template lo use

      // methods
      triggerFileDialog,
      onDragEnter,
      onDragOver,
      onDragLeave,
      onDrop,
      onFileChange,
      submit,
      updateIdentification,
      humanSize
    }
  }
}
</script>


<style scoped>
/* Accesibilidad visual al enfocar el área con teclado */
[role="button"]:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, .45);
  border-color: rgba(59, 130, 246, .8);
}
</style>
